import React from 'react';
import ReactDOM from 'react-dom';
import Top from './pages/Top';
import Work from './pages/Work';
import People from './pages/People';
import Sdgs from './pages/Sdgs';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { BrowserRouter, Route } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import store from './redux';
import consistant from './utils/consistant';

let Router = BrowserRouter;

// if (process.env.NODE_ENV === 'development') {
//   Router = HashRouter;
// }
// console.log(process.env);
console.info('APP VERSION', process.env.REACT_APP_COMMIT_HASH);
// console.info('GENERATE_SOURCEMAP', process.env.GENERATE_SOURCEMAP);


const Container = (props: any) => {
  return (
    <Route exact={props.exact} path={props.path}>
      {(routeProps) => (
        <CSSTransition
          in={routeProps.match != null}
          timeout={consistant.pageTransitionDuration}
          unmountOnExit
        >
          <div className={`container container-${props.name}`}>
            {React.cloneElement(props.children, { ...routeProps })}
          </div>
        </CSSTransition>
      )}
    </Route>
  );
};
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <Container exact path="/" name="top">
          <Top />
        </Container>
        <Container path="/works/:id" name="work">
          <Work />
        </Container>
        <Container path="/people" name="people">
          <People />
        </Container>
        <Container path="/sdgs" name="sdgs">
          <Sdgs />
        </Container>
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
